"use client";

import { Field, withDatasourceCheck } from "@sitecore-jss/sitecore-jss-nextjs";
import { ComponentProps } from "../../types/component-props";
import Placeholder from "../placeholder-component/placeholder";
import AccordionItem from "./accordion-item";

export type AccordionSectionProps = ComponentProps & {
  fields: {
    sectionTitle: Field<string>;
  };
};

const AccordionSection = (props: AccordionSectionProps): JSX.Element => {
  const { sectionTitle } = props.fields || {};
  const { uid } = props.rendering;
  const placeholders = props.rendering.placeholders;

  return (
    <AccordionItem value={`uid-${uid}`} title={sectionTitle}>
      {placeholders &&
        Object.entries(placeholders).map(([key]) => (
          <Placeholder key={key} name={key} rendering={props.rendering} />
        ))}
    </AccordionItem>
  );
};

export default withDatasourceCheck()<AccordionSectionProps>(AccordionSection);
